/*eslint-disable*/
export async function encryptData(data, publicKeyPem) {
  // Convert PEM to a CryptoKey

  const publicKey = await importPublicKey(publicKeyPem);

  // Generate a random AES key

  const aesKey = await crypto.subtle.generateKey(
    {
      name: "AES-GCM",
      length: 256
    },
    true,
    ["encrypt"]
  );

  const rawAesKey = await window.crypto.subtle.exportKey("raw", aesKey);

  // Encrypt the AES key with the RSA public key

  const encryptedAesKey = await crypto.subtle.encrypt(
    {
      name: "RSA-OAEP"
    },
    publicKey,
    rawAesKey
  );

  // Encrypt the data with the AES key

  const encodedData = new TextEncoder().encode(data);
  const iv = crypto.getRandomValues(new Uint8Array(12)); // AES-GCM uses a 12-byte IV
  const ciphertextBuffer = await crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: iv
    },
    aesKey,
    encodedData
  );

  // Extract the tag from the ciphertext

  const tagLength = 16;
  const ciphertextArray = new Uint8Array(ciphertextBuffer);
  const ciphertext = ciphertextArray.slice(0, -tagLength);
  const tag = ciphertextArray.slice(-tagLength);

  // Encode the encrypted components to Base64

  const encryptedAesKeyB64 = arrayBufferToBase64(encryptedAesKey);
  const ivB64 = arrayBufferToBase64(iv);
  const tagB64 = arrayBufferToBase64(tag.buffer);
  const ciphertextB64 = arrayBufferToBase64(ciphertext.buffer);

  // Return the concatenated result

  return `${encryptedAesKeyB64}:${ivB64}:${tagB64}:${ciphertextB64}`;
}

// Helper function to import a PEM formatted public key

async function importPublicKey(pem) {
  // fetch the part of the PEM string between header and footer

  // eslint-disable-next-line
  const pemHeader = "-----BEGIN PUBLIC KEY-----";

  // eslint-disable-next-line
  const pemFooter = "-----END PUBLIC KEY-----";
  const pemContents = pem.substring(pemHeader.length, pem.length - pemFooter.length - 1);

  // base64 decode the string to get the binary data

  const binaryDerString = window.atob(pemContents);

  // convert from a binary string to an ArrayBuffer

  const binaryDer = str2ab(binaryDerString);

  return window.crypto.subtle.importKey(
    "spki",
    binaryDer,
    {
      name: "RSA-OAEP",
      hash: "SHA-1"
    },
    true,
    ["encrypt"]
  );
}

// Helper function to convert a string to ArrayBuffer

function str2ab(binaryString) {
  const len = binaryString.length;
  const bytes = new Uint8Array(len);

  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return bytes.buffer;
}

// Helper function to convert ArrayBuffer to Base64

function arrayBufferToBase64(buffer) {
  const binary = Array.from(new Uint8Array(buffer))
    .map((b) => String.fromCharCode(b))
    .join("");

  return window.btoa(binary);
}
